import type { LucideIcon } from 'lucide-react'
import * as React from 'react'
import { forwardRef } from 'react'

export const MyCollectionIcon: LucideIcon = forwardRef(({ size = 24, color = 'currentColor', ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={(Number(size) * 24) / 21}
      viewBox='0 0 21 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.61539 8.59375L8.61539 22.4062L19.3846 22.4062L19.3846 8.59375H8.61539ZM8.07692 7C7.48216 7 7 7.4757 7 8.0625L7 22.9375C7 23.5243 7.48216 24 8.07692 24L19.9231 24C20.5178 24 21 23.5243 21 22.9375L21 8.0625C21 7.4757 20.5178 7 19.9231 7L8.07692 7Z'
        fill={color}
      />
      <path
        d='M10 15.0225C10 14.6523 10.3002 14.3521 10.6705 14.3521H17.375C17.7453 14.3521 18.0455 14.6523 18.0455 15.0225C18.0455 15.3928 17.7453 15.693 17.375 15.693H10.6705C10.3002 15.693 10 15.3928 10 15.0225Z'
        fill={color}
      />
      <path
        d='M14.0227 11C14.393 11 14.6932 11.3002 14.6932 11.6705V18.375C14.6932 18.7453 14.393 19.0455 14.0227 19.0455C13.6525 19.0455 13.3523 18.7453 13.3523 18.375V11.6705C13.3523 11.3002 13.6525 11 14.0227 11Z'
        fill={color}
      />
      <path
        d='M4.27998 3.54963C3.86741 3.59153 3.54546 3.93996 3.54546 4.36359L3.54546 20.7272C3.54546 21.1791 3.91177 21.5454 4.36364 21.5454C4.81551 21.5454 5.18182 21.1791 5.18182 20.7272L5.18182 5.18177L16.3636 5.18177C16.8155 5.18177 17.1818 4.81546 17.1818 4.36359C17.1818 3.91172 16.8155 3.54541 16.3636 3.54541L4.36364 3.54541C4.3354 3.54541 4.30749 3.54684 4.27998 3.54963Z'
        fill={color}
      />
      <path
        d='M0.734528 0.00422418C0.321954 0.0461233 0 0.394554 0 0.818182L0 17.1818C0 17.6337 0.366313 18 0.818183 18C1.27005 18 1.63636 17.6337 1.63636 17.1818L1.63636 1.63636L12.8182 1.63636C13.2701 1.63636 13.6364 1.27005 13.6364 0.818182C13.6364 0.366312 13.2701 0 12.8182 0L0.818182 0C0.78994 0 0.762032 0.00143091 0.734528 0.00422418Z'
        fill={color}
      />
    </svg>
  )
})

MyCollectionIcon.displayName = 'MyCollectionIcon'
